import React from "react";
import { formatDate } from "../../../utils/commonFunctions";
import { CircularAvatar } from "../../commons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CalanderGrayIcon, ClockIcon } from "../../../assets/images";
type AppProps = {
  header: any;
  data: any;
};

const JobSummery = ({ header, data }: AppProps) => {
  return (
    <div style={{ border: "1px solid #bfcbe1", padding: "20px" }}>
      <div style={{ fontSize: "16px", fontWeight: "500" }}> Job Summary</div>
      <div
        className="mt-2"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {header.map((el: any) => {
          if (el === "jobIdType") {
            return (
              <div style={{maxWidth:"200px"}}>
                <div style={{ color: "#bfcbe1", fontWeight: "500", fontSize: "13px" }}>Job Type & ID</div>
                
            <div style={{wordBreak:'break-word'}}>
           {data?.job&&Object.keys(data?.job)?.length ?<> {`${data?.job?.job_id+`_` +
                      data?.job?.job_type +
                      `_` +
                      formatDate(data?.job?.period_ended)
                  }`.length < 35 ? <div>{`${data?.job?.job_id+`_` +
                      data?.job?.job_type +
                      `_` +
                      formatDate(data?.job?.period_ended)
                  }`}</div> :
                  <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={<Tooltip id="button-view-open-item">{`${data?.job?.job_id+`_` +
                      data?.job?.job_type +
                      `_` +
                      formatDate(data?.job?.period_ended)
                  }`}</Tooltip>}
            >
              <div style={{width:"100%"}} >{`${data?.job?.job_id+`_` +
                      data?.job?.job_type +
                      `_` +
                      formatDate(data?.job?.period_ended)
                  }`?.slice(0,35)+"..."}</div>
                  </OverlayTrigger>}
                  </>:<>
                  {`${
                      data?.future_job?.job_type +
                      `_` +
                      formatDate(data?.future_job?.period_ended)
                  }`.length < 35 ? <div>{`${
                      data?.future_job?.job_type +
                      `_` +
                      formatDate(data?.future_job?.period_ended)
                  }`}</div> :
                  <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={<Tooltip id="button-view-open-item">{`${ 
                      data?.future_job?.job_type +
                      `_` +
                      formatDate(data?.future_job?.period_ended)
                  }`}</Tooltip>}
            >
              <div style={{width:"100%"}} >{`${
                      data?.future_job?.job_type +
                      `_` +
                      formatDate(data?.future_job?.period_ended)
                  }`?.slice(0,35)+"..."}</div>
                  </OverlayTrigger>}</>}
                
                
                {/* <div>
                  {`${data?.job?.job_id+`_` +
                      data?.job?.job_type +
                      `_` +
                      formatDate(data?.job?.period_ended)
                  }`}
                </div> */}
              </div>
              </div>
            );
          } else if (el === "description") {
            return (
              <div style={{maxWidth:"150px" ,wordBreak:'break-word'}}>
                <span style={{ color: "#bfcbe1", fontWeight: "500", fontSize: "13px" }}>Description</span>
                {data?.job&&Object.keys(data?.job)?.length ?<>{data?.job?.job_description?.length < 35 ? <div>{data?.job?.job_description}</div> :
                  <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={<Tooltip id="button-view-open-item">{data?.job?.job_description}</Tooltip>}
            >
              <div style={{width:"100%"}} >{data?.job?.job_description?.slice(0,35)+"..."}</div>
                  </OverlayTrigger>}</> :
                  <>
                {data?.future_job?.job_description?.length < 35 ? <div>{data?.future_job?.job_description}</div> :
                  <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 250 }}
              overlay={<Tooltip id="button-view-open-item">{data?.future_job?.job_description}</Tooltip>}
            >
              <div style={{width:"100%"}} >{data?.future_job?.job_description?.slice(0,35)+"..."}</div>
                  </OverlayTrigger>}
                </>}
              </div>
            );
          } else if (el === "startDate") {
            return (
              <div >
                <span style={{ color: "#bfcbe1", fontWeight: "500", fontSize: "13px" }}>Start Date</span>
                <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                       {data?.job?.target_start_date||data?.future_job?.target_start_date? <img src={CalanderGrayIcon} alt="cal"  className="mr-1"/>:""}
               {data?.job&&Object.keys(data?.job)?.length? <div>{data?.job?.target_start_date?formatDate(data?.job?.target_start_date):"--/--"}</div>:<div>{data?.future_job?.target_start_date?formatDate(data?.future_job?.target_start_date):"--/--"}</div>}
              </div>
              </div>
            );
          }
            else if (el === "client") {
            return (
              <div>
                <span
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  Client Name
                </span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {`${data?.client_name} (${data?.client_code})`}
                </div>
              </div>
            );
          }
          else if (el === "targetEndDate") {
            return (
              <div >
                <span style={{ color: "#bfcbe1", fontWeight: "500", fontSize: "13px" }}>Target End Date</span>
                <div style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
                {data?.job?.target_end_date||data?.future_job?.target_end_date? <img src={CalanderGrayIcon} alt="cal"  className="mr-1"/>:""}
                {data?.job&&Object.keys(data?.job)?.length?<div>{data?.job?.target_end_date?formatDate(data?.job?.target_end_date):"--/--"}</div>:<div>{data?.future_job?.target_end_date?formatDate(data?.future_job?.target_end_date):"--/--"}</div>}
              </div>
              </div>
            );
          } else if (el === "estimatedHour") {
            return (
              <div >
                <span style={{ color: "#bfcbe1", fontWeight: "500", fontSize: "13px" }}>Total Estimated Hour</span>
                  <div style={{display:"flex",alignItems:"center"}}>
                           <img src={ClockIcon} alt="cal" className="mr-1"/>
                <div>{data?.total_hours} hours</div>
              </div>
              </div>
            );
          } else if (el === "CurrentlyResposible") {
            return (
              <div >
                <span style={{color:"#bfcbe1",fontWeight:"500",fontSize:"13px"}}>Currently Responsible</span>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "2px" }}
                >
                  <CircularAvatar
                    name={
                      data?.currently_responsible?.first_name + " " + data?.currently_responsible?.last_name
                    }
                    image={
                      data?.currently_responsible?.profile_pic?.file_url &&
                      data?.currently_responsible?.profile_pic?.file_url
                    }
                  />
                  {data?.currently_responsible?.first_name + " " + data?.currently_responsible?.last_name}
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

export default JobSummery;
